import { ToggleButtonGroup, styled, toggleButtonClasses, toggleButtonGroupClasses } from '@mui/material';

// Copy/Paste from material ui site https://mui.com/material-ui/react-toggle-button/ Vertical Spacing
// Edited to disble minimals override
// Override of override 🤯🤯🤯

const VerticalToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => {
  const borderRadius = (theme.vars || theme).shape.borderRadius;
  const divider = (theme.vars || theme).palette.divider;
  const selectedColor = (theme.vars || theme).palette.text.primaryChannel;
  const border = `1px solid ${divider}`;
  return {
    gap: '2rem',
    border: 'none',
    padding: 0,
    [`& .${toggleButtonClasses.root}`]: { border: `${border} !important`, borderRadius: `${borderRadius} !important` },
    [`& .${toggleButtonGroupClasses.firstButton}, & .${toggleButtonGroupClasses.middleButton}`]: {
      borderBottomRightRadius: borderRadius,
      borderBottomLeftRadius: borderRadius,
    },
    [`& .${toggleButtonGroupClasses.lastButton}, & .${toggleButtonGroupClasses.middleButton}`]: {
      borderTopRightRadius: borderRadius,
      borderTopLeftRadius: borderRadius,
      borderTop: border,
    },
    [`& .${toggleButtonGroupClasses.lastButton}.${toggleButtonClasses.disabled}, & .${toggleButtonGroupClasses.middleButton}.${toggleButtonClasses.disabled}`]:
      {
        borderTop: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`,
      },
    [`& .${toggleButtonClasses.selected}`]: { borderColor: `${selectedColor} !important` },
  };
});

export default VerticalToggleButtonGroup;
